import { ProductAttribute } from '@@partner:types:app'
import { CommonPager, CommonSort, NestedFilter, PageInfo } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS, SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS } from '@@partner:graphql/shortcuts'

export interface AllProductAttributesQuery {
  allProductAttributes: {
    edges: ProductAttribute[]
    pageInfo: PageInfo
  }
}

export interface AllProductAttributesVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}

export const GQL_QUERY_ALL_PRODUCT_ATTRIBUTES = gql`
  query allProductAttributes(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allProductAttributes(
      filter: $filter
      sort: $sort
      pager: $pager 
    ) {
      edges {
        ${SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllProductAttributes = (variables?: AllProductAttributesVariables) =>
  useQuery<AllProductAttributesQuery, AllProductAttributesVariables>(GQL_QUERY_ALL_PRODUCT_ATTRIBUTES, {
    variables,
    fetchPolicy: 'network-only'
  })
